import angular from "angular";

angular
    .module('mobiusControl.requestInfo', [])
    .component('requestInfo', {
        template: require('./request-info.component.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.requestLog = $ctrl.resolve.requestLog;
        // $ctrl.requestLog['request_headers'] = JSON.parse($ctrl.requestLog['request_headers']);
        // $ctrl.requestLog['request_body'] = JSON.parse($ctrl.requestLog['request_body']);
        // $ctrl.requestLog['response_headers'] = JSON.parse($ctrl.requestLog['response_headers']);
        // $ctrl.requestLog['response_body'] = JSON.parse($ctrl.requestLog['response_body']);
    };
}

export default "mobiusControl.requestInfo"


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/request-info/request-info.component.js